<template>
  <div />
</template>

<script lang="ts">
import { useExternalAffiliate } from '~/core/composable/shared/useExternalAffiliate'

export type AwinWindow = Window & {
  AWIN: {
    Tracking: {
      Sale: {
        amount?: string,
        orderRef?: string,
        parts?: string,
        voucher?: string,
        currency?: string,
        channel?: string,
        customerAcquisition?: string,
      },
      run?: () => void,
    },
  },
}

export default defineNuxtComponent({
  setup() {
    const externalAffiliate = useExternalAffiliate()

    function initTracking() {
      const wind = window as unknown as AwinWindow
      wind.AWIN = wind.AWIN || {}
      wind.AWIN.Tracking = wind.AWIN.Tracking || {}
      wind.AWIN.Tracking.Sale = {}

      const dwinScript = document.createElement('script')
      dwinScript.setAttribute('src', 'https://www.dwin1.com/106069.js')
      dwinScript.setAttribute('defer', 'defer')
      dwinScript.setAttribute('type', 'text/javascript')
      document.body.appendChild(dwinScript)
    }

    onMounted(() => {
      const source = externalAffiliate.getSourceChannel()
      if (source && source !== 'aw') {
        return
      }

      initTracking()
    })

    return {
    }
  },
})
</script>
